import UAParser from "ua-parser-js";

export function parseUserAgent(ua: string) {
  const parsed = UAParser(ua);

  return parsed;
}
